import cn from "classnames";
import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { t } from "i18next";
import { Pagination, SearchInput } from "ui";

import { useGetBoxMovementSummary } from "../../apis";
import { BoxMovementsTable } from "../../components";
import { BOX_MOVEMENT_ZONE_TABS, EInventoryBoxZone } from "../../constants";
import { useBoxMovementsList } from "../../hooks";

import styles from "./BoxMovements.module.scss";

const BoxMovements = () => {
  const {
    boxMovements,
    isLoading,
    page,
    totalItems,
    sorting,
    zone,
    searchValue,
    setSearchValue,
    setZone,
    setSorting,
    setPage,
  } = useBoxMovementsList();

  const { summary } = useGetBoxMovementSummary();

  const tabCount = (tabZone?: EInventoryBoxZone) => {
    if (tabZone === EInventoryBoxZone.Pickup) return summary?.pickupCount ?? 0;
    if (tabZone === EInventoryBoxZone.Warehouse)
      return summary?.warehouseCount ?? 0;
    return summary?.totalCount ?? 0;
  };

  return (
    <div className={styles.movements}>
      <div className={styles.movements_summary}>
        <span className={styles.movements_summary_count}>
          {t("{{count}} box movements", { count: summary?.totalCount ?? 0 })}
        </span>
        <span className={styles.movements_summary_items}>
          {t("{{count}} articles moved", {
            count: summary?.totalArticles ?? 0,
          })}
        </span>
      </div>

      <div className={styles.movements_controls}>
        <div className={styles.movements_tabs}>
          {BOX_MOVEMENT_ZONE_TABS.map((tab) => (
            <button
              key={tab.label}
              type="button"
              className={cn(styles.movements_tab, {
                [styles.movements_tab__active]: zone === tab.zone,
              })}
              onClick={() => setZone(tab.zone)}
            >
              {t(tab.label)}
              <span className={styles.movements_tab_count}>
                {tabCount(tab.zone)}
              </span>
            </button>
          ))}
        </div>

        <div className={styles.movements_search}>
          <SearchInput
            value={searchValue}
            onChange={setSearchValue}
            placeholder={`${t("Search")}...`}
          />
        </div>
      </div>

      <div className={styles.movements_tableContainer}>
        <BoxMovementsTable
          boxMovements={boxMovements ?? []}
          isLoading={isLoading}
          sorting={sorting}
          setSorting={setSorting}
        />
      </div>

      <Pagination
        currentPage={page}
        onChange={setPage}
        perPage={GET_LIST_REQUEST_DEFAULT_LIMIT}
        totalItems={totalItems}
      />
    </div>
  );
};

export default BoxMovements;
